// extracted by css-extract-rspack-plugin
export default {"statistic":"ContentfulStatistics-module__statistic__h4Pz_"};